import React from "react";

import "./email-page-mobile.css";

const EmailPageMobile = (props) => {
  return (
    <div
      className="email-page-mobile-container"
      style={{
        direction: "rtl",
      }}
    >
      <div className="email-page-mobile-email-page-mobile">
        <span className="email-page-mobile-text">
          <span>ברוכים הבאים ל-Cheers אירועים</span>
        </span>
        <img
          src="/external/Logo.png"
          alt="Logo8541"
          className="email-page-mobile-logo"
        />
        <img
          src="/external/line178575-mu.svg"
          alt="Line178575"
          className="email-page-mobile-line17"
        />
        <img
          src="/external/line188575-m5nt.svg"
          alt="Line188575"
          className="email-page-mobile-line18"
        />
        <img
          src="/external/line198575-sqd.svg"
          alt="Line198575"
          className="email-page-mobile-line19"
        />
        <span className="email-page-mobile-text02">
          <span>תודה שבחרתם בנו לעצב את ההזמנה שלכם לאירוע!</span>
        </span>
        <span className="email-page-mobile-text04">
          <span>להורדת האפליקציה לאייפון ולאנדרואיד</span>
        </span>
        <div className="email-page-mobile-app-store">
          <img
            src="/external/vector8575-4odm.png"
            alt="Vector8575"
            className="email-page-mobile-vector"
          />
          {/* <div className="email-page-mobile-group">
            <div className="email-page-mobile-group1">
              <img
                src="/external/vector8575-8lq9.svg"
                alt="Vector8575"
                className="email-page-mobile-vector01"
              />
              <img
                src="/external/vector8575-9bw6.svg"
                alt="Vector8575"
                className="email-page-mobile-vector02"
              />
            </div>
            <div className="email-page-mobile-group2">
              <div className="email-page-mobile-group3">
                <img
                  src="/external/vector8575-uy5k.svg"
                  alt="Vector8575"
                  className="email-page-mobile-vector03"
                />
                <img
                  src="/external/vector8575-pcq.svg"
                  alt="Vector8575"
                  className="email-page-mobile-vector04"
                />
                <img
                  src="/external/vector8575-odwa.svg"
                  alt="Vector8575"
                  className="email-page-mobile-vector05"
                />
                <img
                  src="/external/vector8575-do1.svg"
                  alt="Vector8575"
                  className="email-page-mobile-vector06"
                />
                <img
                  src="/external/vector8575-5fnb.svg"
                  alt="Vector8575"
                  className="email-page-mobile-vector07"
                />
                <img
                  src="/external/vector8575-bf5z.svg"
                  alt="Vector8575"
                  className="email-page-mobile-vector08"
                />
                <img
                  src="/external/vector8575-j1cgl.svg"
                  alt="Vector8575"
                  className="email-page-mobile-vector09"
                />
                <img
                  src="/external/vector8575-xo5v.svg"
                  alt="Vector8575"
                  className="email-page-mobile-vector10"
                />
                <img
                  src="/external/vector8575-jawx.svg"
                  alt="Vector8575"
                  className="email-page-mobile-vector11"
                />
                <img
                  src="/external/vector8575-lfpa.svg"
                  alt="Vector8575"
                  className="email-page-mobile-vector12"
                />
                <img
                  src="/external/vector8575-twlv.svg"
                  alt="Vector8575"
                  className="email-page-mobile-vector13"
                />
                <img
                  src="/external/vector8575-kotb.svg"
                  alt="Vector8575"
                  className="email-page-mobile-vector14"
                />
                <img
                  src="/external/vector8575-so9.svg"
                  alt="Vector8575"
                  className="email-page-mobile-vector15"
                />
              </div>
              <div className="email-page-mobile-group4">
                <img
                  src="/external/vector8575-96w6.svg"
                  alt="Vector8575"
                  className="email-page-mobile-vector16"
                />
                <img
                  src="/external/vector8575-to0e.svg"
                  alt="Vector8575"
                  className="email-page-mobile-vector17"
                />
                <img
                  src="/external/vector8575-8gb2h.svg"
                  alt="Vector8575"
                  className="email-page-mobile-vector18"
                />
                <img
                  src="/external/vector8575-k4s.svg"
                  alt="Vector8575"
                  className="email-page-mobile-vector19"
                />
                <img
                  src="/external/vector8575-xram.svg"
                  alt="Vector8575"
                  className="email-page-mobile-vector20"
                />
                <img
                  src="/external/vector8575-0r3p.svg"
                  alt="Vector8575"
                  className="email-page-mobile-vector21"
                />
                <img
                  src="/external/vector8575-0xd.svg"
                  alt="Vector8575"
                  className="email-page-mobile-vector22"
                />
                <img
                  src="/external/vector8575-b70q.svg"
                  alt="Vector8575"
                  className="email-page-mobile-vector23"
                />
              </div>
            </div>
          </div> */}
        </div>
        <div className="email-page-mobile-google-play">
          <img
            src="/external/vector8575-885r.png"
            alt="Vector8575"
            className="email-page-mobile-vector24"
          />
          {/* <div className="email-page-mobile-group5">
            <img
              src="/external/vector8575-4zag.svg"
              alt="Vector8575"
              className="email-page-mobile-vector25"
            />
            <img
              src="/external/vector8575-97tk.svg"
              alt="Vector8575"
              className="email-page-mobile-vector26"
            />
            <img
              src="/external/vector8575-tiyv.svg"
              alt="Vector8575"
              className="email-page-mobile-vector27"
            />
            <img
              src="/external/vector8575-fefo.svg"
              alt="Vector8575"
              className="email-page-mobile-vector28"
            />
          </div>
          <div className="email-page-mobile-group6">
            <div className="email-page-mobile-group7">
              <img
                src="/external/vector8575-v85e.svg"
                alt="Vector8575"
                className="email-page-mobile-vector29"
              />
              <img
                src="/external/vector8575-iw89.svg"
                alt="Vector8575"
                className="email-page-mobile-vector30"
              />
              <img
                src="/external/vector8575-dse.svg"
                alt="Vector8575"
                className="email-page-mobile-vector31"
              />
              <img
                src="/external/vector8575-lz2a.svg"
                alt="Vector8575"
                className="email-page-mobile-vector32"
              />
              <img
                src="/external/vector8575-96l.svg"
                alt="Vector8575"
                className="email-page-mobile-vector33"
              />
              <img
                src="/external/vector8575-kqft.svg"
                alt="Vector8575"
                className="email-page-mobile-vector34"
              />
              <img
                src="/external/vector8575-ulrn.svg"
                alt="Vector8575"
                className="email-page-mobile-vector35"
              />
            </div>
            <div className="email-page-mobile-group8">
              <img
                src="/external/vector8575-fdiq.svg"
                alt="Vector8575"
                className="email-page-mobile-vector36"
              />
              <img
                src="/external/vector8575-uh45.svg"
                alt="Vector8575"
                className="email-page-mobile-vector37"
              />
              <img
                src="/external/vector8575-7q5h.svg"
                alt="Vector8575"
                className="email-page-mobile-vector38"
              />
              <img
                src="/external/vector8575-bh8u.svg"
                alt="Vector8575"
                className="email-page-mobile-vector39"
              />
              <img
                src="/external/vector8575-lpro.svg"
                alt="Vector8575"
                className="email-page-mobile-vector40"
              />
              <img
                src="/external/vector8575-qffl.svg"
                alt="Vector8575"
                className="email-page-mobile-vector41"
              />
              <img
                src="/external/vector8575-3jak.svg"
                alt="Vector8575"
                className="email-page-mobile-vector42"
              />
              <img
                src="/external/vector8575-v38v.svg"
                alt="Vector8575"
                className="email-page-mobile-vector43"
              />
              <img
                src="/external/vector8575-wl2v.svg"
                alt="Vector8575"
                className="email-page-mobile-vector44"
              />
              <img
                src="/external/vector8575-wmc.svg"
                alt="Vector8575"
                className="email-page-mobile-vector45"
              />
            </div>
          </div> */}
        </div>
        <span className="email-page-mobile-text06">
          <span>התחברות לשירות באמצעות מספר הפלאפון:</span>
        </span>
        <div className="email-page-mobile-frame77">
          <span
            className="email-page-mobile-text08"
            style={{
              color: "white",
            }}
          >
            <span>להורדת דוגמה לרשימת מוזמנים</span>
          </span>
        </div>
        <span className="email-page-mobile-text10">
          <span>הוראות למילוי רשימת המוזמנים</span>
        </span>
        <span className="email-page-mobile-text12">
          <span>
            <span>
              המערכת יכולה לעבוד עם קובץ Excel בתבנית מסוימת. להלן החוקים למילוי
              הקובץ:
            </span>
            <br></br>
            <span></span>
            <br></br>
            <span>קובץ בפורמט XLSX בלבד.</span>
            <br></br>
            <span></span>
            <br></br>
            <span>בקובץ 5 כותרות ראשיות בלבד:</span>
            <br></br>
            <span>שם מלא.</span>
            <br></br>
            <span>מספר פלאפון ישראלי בלבד.</span>
            <br></br>
            <span>מצב הגעה (מגיע, לא מגיע, לא הופץ, לא ענו).</span>
            <br></br>
            <span> כמות אורחים (מספר בלבד).</span>
            <br></br>
            <span>מספר שולחן (0 אם אין שולחן).</span>
            <br></br>
            <span></span>
            <br></br>
            <span>
              ייבוא הטבלה יעבור בהצלחה רק אם כל הכותרות והנתונים בטבלה זהים
              לחלוטין בדרך שהוצגה לעיל.
            </span>
          </span>
        </span>
        <span className="email-page-mobile-text37">
          <span>אז יאללה, תתחילו להכין את אירוע - שיהיה בשעה טובה!</span>
        </span>
        <img
          src="/external/whatsappico8575-dm05.svg"
          alt="Whatsappico8575"
          className="email-page-mobile-whatsappico"
        />
        <img
          src="/external/facebookico8576-64hp.svg"
          alt="Facebookico8576"
          className="email-page-mobile-facebookico"
        />
      </div>
    </div>
  );
};

export default EmailPageMobile;
